export type AccountType = 'scholar' | 'standard';

const ACCOUNT_TYPE_COOKIE_NAME = 'vegetag_account_type';

export function setAccountTypeCookie(accountType: AccountType): void {
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);

  document.cookie = `${ACCOUNT_TYPE_COOKIE_NAME}=${accountType}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
}

export function getAccountTypeCookie(): AccountType | null {
  const cookieValue = document.cookie
    .split(';')
    .find(cookie => cookie.trim().startsWith(`${ACCOUNT_TYPE_COOKIE_NAME}=`))
    ?.split('=')[1];
  
  return (cookieValue as AccountType) || null;
}

export function hasAccountTypeCookie(): boolean {
  return getAccountTypeCookie() !== null;
}
